// extracted by mini-css-extract-plugin
export default {"overlay":"Overlay_overlay__bBNyT","transparent":"Overlay_transparent__4UiDI","opaque":"Overlay_opaque__lHtDU","empty":"Overlay_empty__qTDrB","loading":"Overlay_loading__n6xRL"};